<app-table
    (dataLoadMore)="searchWallets()"
    (dataSort)="applySort($event)"
    (dataRowAction)="goToTransactionDetail($event)"
    [tenantDefaultColumns]="tenantDefaultColumns"
    [dataColumns]="columns"
    [dataDefaultColumns]="defaultColumns"
    [dataHasMoreRecords]="hasMoreRecords"
    [dataLoading]="loading"
    [dataSortableColumns]="sortableColumns"
    [dataSource]="wallets"
    class="transaction-table"
    [dataAbsenceText]="noDataMessage"
    dataName="{{ walletHeading }}"
    (visibleColumnsChanged)="handleVisibleColumnsChange($event)"
>
    <app-table-button (tableButtonClick)="exportExcel()" tableButtonFontIcon="download" tableButtonText="Download .xlsx" />

    <app-table-filter (checkboxChange)="applyProductTypeFilter($event)" filterFontIcon="credit_card" [filterName]="filterName" filterType="checkbox">
        <ng-template *ngFor="let transactionWalletType of transactionWalletTypes" [filterValue]="transactionWalletType" appTableFilter>
            <span>{{ transactionWalletType | walletType }}</span>
        </ng-template>
    </app-table-filter>

    <ng-template [appTableColumnDataSource]="wallets" appTableColumn="transaction_timestamp" let-transaction>
        <p>{{ transaction.transaction_timestamp | date : 'MMM dd, yyyy hh:mm aaa' | optionalPlaceholder }}</p>
    </ng-template>
    <ng-template [appTableColumnDataSource]="wallets" appTableColumn="type" let-transaction>
        <p class="text-wrap">{{ transaction.type  | walletType  | optionalPlaceholder}} {{ getTransactionTypeIcon(transaction.type ,transaction) }}</p>
    </ng-template>
 
    <ng-template  [appTableColumnDataSource]="wallets" appTableColumn="status_code" let-transaction>
        <div
            [class.status-badge-failed]="transaction.status_code && (transaction.status_code.startsWith('1') || transaction.status_code.startsWith('9'))"
            [class.status-badge-success]="transaction.status_code && transaction.status_code.startsWith('0')"
            class="py-1 px-4 fw-semibold rounded-pill status-badge" *ngIf="transaction.status_code"
        >
            {{ transaction.status_code.startsWith('0') ? 'Accepted' : ' Declined' }}
    </div>
    </ng-template>

    <ng-template [appTableColumnDataSource]="wallets" appTableColumn="to_amount" let-transaction>
        <p>{{ transaction.to_amount?.toFixed(2) | currency : transaction.to_currency + ' ' | optionalPlaceholder }}</p>
    </ng-template>
    
    <ng-template [appTableColumnDataSource]="wallets" appTableColumn="from_amount" let-transaction>
        <p>{{ transaction.from_amount?.toFixed(2) | currency : transaction.from_currency + ' ' | optionalPlaceholder }}</p>
    </ng-template>
</app-table>
